<nav class="flex flex-row space-x-20 place-items-start p-2 bg-segesblue max-h-9">
  <div>
    <h3 class="nav-bar text-[28px]/5 hover:cursor-pointer" data-testid="main-title" routerLink="/trials">
      <span class="font-bold">X</span>reg
    </h3>
  </div>

  <div>
    <a
      routerLink="/trials"
      [ngClass]="!(isActive('/weighing') || isActive('/admin') || isActive('/removals')) ? 'active' : ''"
      id="MainNavBar-Menu1"
      class="navigation-title nav-bar"
      data-testid="TopMenuSelectors_BtnMenu1"
      >{{ "GENERAL.TRIALS" | appString }}
    </a>
  </div>
  
  <div>
    <a
      routerLink="/removals"
      [ngClass]="isActive('/removals') ? 'active' : ''"
      class="navigation-title nav-bar"
      data-testid="TopMenuSelectors_Removals"
      >{{ "GENERAL.REMOVALS" | appString }}
    </a>
  </div>

  <div>
    <a
      routerLink="/admin"
      [ngClass]="isActive('/admin') ? 'active' : ''"
      class="navigation-title nav-bar"
      data-testid="TopMenuSelectors_Admin"
      >{{ "ADMIN.ADMIN" | appString }}
    </a>
  </div>

  <div>
     <a
      routerLink="/sync"
      [ngClass]="isActive('/sync') ? 'active' : ''"
      class="navigation-title nav-bar contents"
      data-testid="TopMenuSelectors_Sync">
        {{ "GENERAL.SYNCHRONIZE" | appString }}
        <p class="material-icons float-end" style="line-height: unset;">sync</p>
    </a>
  </div>

  <!-- <span class="spacer"></span> -->
  <span class="ml-auto nav-bar">{{ this.userName }}</span>
  <div>
    <a class="nav-bar text-sm" role="button" (click)="logout()">{{ "GENERAL.SIGNOUT" | appString }}</a>
  </div>
</nav>


<!-- Gammelt -->
<!-- <mat-toolbar class="mat-toolbar">
  <mat-toolbar-row class="main-menu" data-testid="TopMenuSelectors_TopToolbar">
    <h3 class="title" data-testid="main-title" routerLink="/trials">
      <span class="bold-part">X</span>reg
    </h3>
    <span class="menu-spacer"></span>
    <div class="divitem">
      <a
        routerLink="/trials"
        [ngClass]="!(isActive('/weighing') || isActive('/admin')) ? 'active' : ''"
        id="MainNavBar-Menu1"
        class="navigation-title"
        data-testid="TopMenuSelectors_BtnMenu1"
        >{{ "GENERAL.TRIALS" | appString }}
      </a>
    </div>
    <div class="divitem">
      <a
        routerLink="/admin"
        [ngClass]="isActive('/admin') ? 'active' : ''"
        class="navigation-title"
        data-testid="TopMenuSelectors_Admin"
        >{{ "ADMIN.ADMIN" | appString }}
      </a>
    </div>

    <span class="spacer"></span>
    <span class="user-name">{{ this.userName }}</span>
    <div>
      <a class="signout" href="/signout">{{ "GENERAL.SIGNOUT" | appString }}</a>
    </div>
  </mat-toolbar-row>

</mat-toolbar>
<mat-progress-bar *ngIf="navigatingToRoute" color="accent" mode="indeterminate">
</mat-progress-bar>

 -->
